import { Box, Stack } from '@mui/material'
import React from 'react'
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import 'swiper/css/pagination';
import RCard from './Card.tsx'
import {EffectCoverflow, Pagination} from "swiper/modules";
import mobileClass from "./Index.module.css";
import {useEffect, useMemo} from "react";
import {useSize} from "ahooks";
import { MAX_WIDTH } from '@/constant/Constant.ts';
interface Props {
  list: any[],
  onChange?: (card: any) => void,
}

const Cards = (props: Props) => {
  const { list, onChange } = props
  const _onSwiperChange = (e) => {
    onChange && onChange(list[e.activeIndex]);
  }

  const actualList = useMemo(() => {
    if (!list) return [];
    return [...list]
  }, [list]);

  useEffect(() => {
    if (actualList && actualList.length > 0) {
      if (onChange) onChange(actualList[0]);
    }
  }, [actualList]);

  const size = useSize(document.querySelector('body'));
  const cardScale = useMemo(() => {
    let _width = size?.width
    if (_width > MAX_WIDTH) {
      _width = MAX_WIDTH
    }
    const scale = _width / 375
    return scale
  }, [size])
  const swiperStretch = useMemo(() => {

  }, [cardScale])
  return (<>
    <Stack
      sx={{padding: '0px !important'}}
      direction="row" justifyContent="center" className={mobileClass.root}>
      <Swiper
        effect={"coverflow"}
        // spaceBetween={0}
        coverflowEffect={{
          scale: 0.85,
          rotate: 0,
          stretch: -60 * cardScale,
          depth: 10,
          // modifier: 1,
          slideShadows: false,

        }}
        grabCursor={true}
        centeredSlides={true}
        centeredSlidesBounds={false}
        slidesPerView={"auto"}
        loop={false}
        pagination={false}
        modules={[EffectCoverflow, Pagination]}
        // className="mobile-swiper-wraper"
        onActiveIndexChange={_onSwiperChange}
      >
        {actualList && actualList.length > 0 && actualList.map((item) => (
          <React.Fragment key={item.sn}>
            <SwiperSlide key={item.sn} style={{
              width: 172 * cardScale + 'px',
              maxWidth: 172 * (MAX_WIDTH / 375) + 'px',
            }}>
              <RCard card={item} />
            </SwiperSlide>
          </React.Fragment>
        ))}
      </Swiper>
    </Stack>
  </>)
}

export default Cards;